import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login as loginAction } from '../redux/authSlice';
import { login } from '../api/APIService';
import Toast from './Toast';
import Loader from './Loader';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);



  const validateFields = () => {
    const newErrors = {};
    if (!email.trim()) newErrors.email = "Please enter username/email";
    if (!password.trim()) newErrors.password = "Please enter password";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    setLoading(true);
    try {
      const response = await login({
        username: email, password,
        roles: "WEB_USER"
      });
      const data = response.data;
      dispatch(loginAction({ "fullName": data.fullName, "username": data.username, 'token': data.token, 'deviceId': data.deviceId, 'email': data.email, 'mobileNumber': data.mobileNumber, 'roles': data.roles[0] }));
      /*  setTimeout(()=>{
         navigate('/farmer');
       }, 1000) */

    } catch (error) {
      console.error('Login failed:', error);
      setToast({ show: true, message: 'Login failed. Please check your credentials.', type: 'error' });
      setLoading(false);
    } finally {
      //setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/farmer');
    }
  }, [isAuthenticated]);

  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
  }, []);

  return (
    <div className="container mt-5">
      <div className="row justify-content-end">
        <div className="col-md-5">
          <div className="card">
            <div className="card-body">
              <h1 className="text-center mb-4">Login</h1>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  {errors.email && <p className="error-text"><span>{errors.email}</span></p>}

                  <input
                    /*  type="email" */
                    className="form-control"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}

                  />
                </div>
                <div className="mb-3">
                  {errors.password && <p className="error-text"><span>{errors.password}</span></p>}

                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>

                <button type="submit" className="btn btn-teal w-100" disabled={loading}>
                  {loading ? 'Logging in...' : 'Login'}
                </button>
              </form>
              <div className="d-flex justify-content-center gap-4 mt-3">
                <button onClick={() => navigate("/forgot-password")} className="btn btn-outline-teal ">Forgot Password?</button>
               {/*  <button className=" btn btn-outline-teal" onClick={() => navigate("/signup")} >Sign Up</button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toast
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
      />
      <Loader show={loading} />
    </div>
  );
};

export default Login;